/**
 * @deprecated
 */
export interface IClassSkillsRating {
  id: number;
  name: string;
  sequence: number;
  skillId: number;
}

/**
 * @deprecated
 */
export class ClassSkillsRating implements IClassSkillsRating {
  id;
  name;
  sequence;
  skillId;

  constructor(config: IClassSkillsRating) {
    this.id = config.id;
    this.name = config.name;
    this.sequence = config.sequence;
    this.skillId = config.skillId;
  }
}
